export const ApplePayPaymentMethodName = "ApplePay";
